<template>
  <div>
    <div v-if="view" class="col-md-8 col-md-offset-2">
      <br />
      <h3 class="text-center">{{computeCaption(fields_en['dependents'], $store.state.lang.value.toLowerCase())}}</h3><br>
      <div v-if="!dependentsArray.length">
        <h4 class="text-center">{{computeCaption(fields_en['you_do_not_have_any'], $store.state.lang.value.toLowerCase())}}</h4>
      </div>
      <div v-for="items in dependentsArray" :key="items['id']" class="pb-40">
        <div
          class="row bg-color p-10 rounded cursor-pointer ml-30 mr-30"
          @click.stop.prevent="changeTab(items['id'])"
        >
          <div class="col-md-11 col-sm-8 col-xs-8">
            <p class="fs-18 pt-5">
              {{computeCaption(fields_en['dependent_name'], $store.state.lang.value.toLowerCase())}} {{ items["first_name"] }} {{ items["last_name"] }}
            </p>
          </div>
          <div class="col-md-1 col-sm-4 col-xs-4">
            <a v-if="editButton !== items['id']" class="turnGreen float-mobile"
              ><i class="el-icon-arrow-down float-right icon-button"></i
            ></a>
            <a v-if="editButton === items['id']" class="turnGreen float-mobile"
              ><i class="el-icon-arrow-up float-right icon-button"></i
            ></a>
          </div>
        </div>
        <transition name="fade">
          <div v-if="editButton === items['id']" class="row bg-color-white">
            <MedData type="dependentUpdate" ref="medicationData" :triggerWatch="true"> </MedData>
            <br />
            <div class="row">
              <div class="col-md-10 col-md-offset-1">
                <button
                  class="btn btn-default btn-wd btn-back primary-color"
                  v-on:click.stop.prevent="
                    $router.push({ path: '/patient/account' })
                  "
                  ><span>{{computeCaption(fields_en['back'], $store.state.lang.value.toLowerCase())}}</span></button
                >
                <button
                  class="btn btn-fill btn-wd btn-next float-right"
                  v-on:click.stop.prevent="callValidation()"
                  ><span>{{computeCaption(fields_en['update_dependent'], $store.state.lang.value.toLowerCase())}}</span></button
                >
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="row" v-if="!addDependent && editButton === ''">
        <button
          class="btn btn-default btn-wd btn-back primary-color"
          v-on:click.stop.prevent="
            $router.push({ path: '/patient/account' })
          "
          ><span>{{computeCaption(fields_en['back'], $store.state.lang.value.toLowerCase())}}</span></button
        >
        <button
          class="btn btn-fill btn-wd btn-next float-right"
          v-on:click.stop.prevent="addDependents()"
          ><span>{{computeCaption(fields_en['add_new_dependent'], $store.state.lang.value.toLowerCase())}}</span></button
        >
      </div>
      <transition name="fade">
        <div class="padding-top" v-if="addDependent && editButton === ''">
          <h4 class="text-center">{{computeCaption(fields_en['add_new_dependent'], $store.state.lang.value.toLowerCase())}}</h4>
          <MedData type="dependentRegistration" ref="medicationData" :triggerWatch="true"> </MedData>
          <br/>
          <div class="row">
            <div class="col-md-10 col-md-offset-1">
              <button
                class="btn btn-default btn-wd btn-back primary-color"
                v-on:click.stop.prevent="
                  $router.push({ path: '/patient/account' })
                "
                ><span>{{computeCaption(fields_en['back'], $store.state.lang.value.toLowerCase())}}</span></button
              >
              <button
                class="btn btn-fill btn-wd btn-next float-right"
                v-on:click.stop.prevent="callValidationRegistration()" :disabled="loadingAddDependent"
                ><span>{{loadingAddDependent ? computeCaption(fields_en['add_dependent_loading'], $store.state.lang.value.toLowerCase()) : computeCaption(fields_en['add_dependent'], $store.state.lang.value.toLowerCase())}}</span></button
              >
            </div>
          </div>
        </div>
      </transition>
      <br /><br />
    </div>
    <div v-else v-loading.fullscreen.lock="!view" class="loading"></div>
  </div>
</template>

<script>
  import {Autocomplete, Input, Drawer, Button, RadioGroup, Radio, RadioButton, DatePicker} from 'element-ui'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import axios from 'axios'
  import Address from './Address'
  import MedData from './MedDataRegistration'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
  export default {
    components: {
      [Input.name]: Input,
      [DatePicker.name]: DatePicker,
      [Autocomplete.name]: Autocomplete,
      [Drawer.name]: Drawer,
      [Button.name]: Button,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [RadioButton.name]: RadioButton,
      Address,
      MedData
    },
    mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, SettingsUtils],
    data () {
      return {
        view: false,
        errorData: '',
        address_error: '',
        errorDate: '',
        shouldGuardianBeRequired: false,
        addDependent: false,
        loadingAddDependent: false,
        editButton: '',
        addDependentError: '',
        insuredAddressInitial: '',
        dependentsArray: this.$store.state.dependentsData,
        fields_en: {
          add_dependent_loading: 'Adding New Dependent',
          dependent_name: 'Dependent Name:',
          back: 'Back',
          add_new_dependent: 'Add new Dependent',
          dependents: 'Dependents',
          add_dependent: 'Add Dependent',
          update_dependent: 'Update Dependent',
          you_do_not_have_any: 'You do not have any dependent yet!'
        },
        relationshipArray: [{name: 'Self'}, {name: 'Child'}, {name: 'Parent'}, {name: 'Spouse'}],
        model: {
          firstName: '',
          lastName: '',
          guardianName: '',
          dob: '',
          dob_pretty: '',
          address: '',
          gender: '',
          address2: '',
          addressComponents: ''
        },
        modelValidations: {
          firstName: {
            min: 2,
            required: true
          },
          lastName: {
            min: 2,
            required: true
          },
          gender: {
            required: true
          }
        },
        address_smartystreets_selected: {
          invalid: false,
          error_message: 'Looks like we don\'t know this address, please make sure the address is correct',
          first_result: ''
        }
      }
    },
    methods: {
      addDependents () {
        this.addDependent = true
        this.$store.state.userData = {
          driver_license_image: '',
          driver_license_name: '',
          firstName: '',
          lastName: '',
          passport: '',
          dob: '',
          dob_pretty: '',
          address: '',
          address2: '',
          gender: '',
          phone: '',
          race: '',
          ethnicity: '',
          addressComponents: '',
          primary_insurance: '',
          policy_number: '',
          group_number: '',
          driver_license_number: '',
          social_security_number: ''
        }
      },
      changeTab (id) {
        if (this.editButton === id) {
          this.editButton = ''
          this.addDependent = false
        } else {
          this.editButton = id
          let dependentId
          for (dependentId in this.dependentsArray) {
            if (this.dependentsArray[dependentId]['id'] === id) {
              let addressInitial = {}
              if (this.dependentsArray[dependentId]['addressComponents']) {
                addressInitial = {
                  name: this.dependentsArray[dependentId]['addressComponents']['name'] || '',
                  original_name: this.dependentsArray[dependentId]['addressComponents']['original_name'] || '',
                  delivery_line_1: this.dependentsArray[dependentId]['addressComponents']['delivery_line_1'] || '',
                  city_name: this.dependentsArray[dependentId]['addressComponents']['city_name'] || '',
                  county: this.dependentsArray[dependentId]['addressComponents']['county'] || '',
                  state_abbreviation: this.dependentsArray[dependentId]['addressComponents']['state_abbreviation'] || '',
                  zipcode: this.dependentsArray[dependentId]['addressComponents']['zipcode'] || '',
                  plus4_code: this.dependentsArray[dependentId]['addressComponents']['plus4_code'] || '',
                  county_fips: this.dependentsArray[dependentId]['addressComponents']['county_fips'] || '',
                  country: this.dependentsArray[dependentId]['addressComponents']['country'] || ''
                }
              }
              let insuredAddressInitial = {}
              if (this.dependentsArray[dependentId]['insured_address_components']) {
                insuredAddressInitial = {
                  name: this.dependentsArray[dependentId]['insured_address_components']['name'] || '',
                  original_name: this.dependentsArray[dependentId]['insured_address_components']['original_name'] || '',
                  delivery_line_1: this.dependentsArray[dependentId]['insured_address_components']['delivery_line_1'] || '',
                  city_name: this.dependentsArray[dependentId]['insured_address_components']['city_name'] || '',
                  county: this.dependentsArray[dependentId]['insured_address_components']['county'] || '',
                  state_abbreviation: this.dependentsArray[dependentId]['insured_address_components']['state_abbreviation'] || '',
                  zipcode: this.dependentsArray[dependentId]['insured_address_components']['zipcode'] || '',
                  plus4_code: this.dependentsArray[dependentId]['insured_address_components']['plus4_code'] || '',
                  county_fips: this.dependentsArray[dependentId]['insured_address_components']['county_fips'] || '',
                  country: this.dependentsArray[dependentId]['insured_address_components']['country'] || ''
                }
              }
              this.$store.state.userData = {
                firstName: this.dependentsArray[dependentId]['first_name'] || '',
                lastName: this.dependentsArray[dependentId]['last_name'] || '',
                middleName: this.dependentsArray[dependentId]['middle_name'] || '',
                passport: this.dependentsArray[dependentId]['passport'] || '',
                dob: this.dependentsArray[dependentId]['date_of_birth'] || '',
                dob_pretty: this.dependentsArray[dependentId]['date_of_birth'] || '',
                address: this.dependentsArray[dependentId]['address'] || '',
                address2: this.dependentsArray[dependentId]['address2'] || '',
                gender: this.dependentsArray[dependentId]['gender'] || '',
                phone: this.dependentsArray[dependentId]['phone'] || '',
                race: this.dependentsArray[dependentId]['race'] || '',
                ethnicity: this.dependentsArray[dependentId]['ethnicity'] || '',
                addressComponents: addressInitial,
                primary_insurance: this.dependentsArray[dependentId]['insurance_name'] || '',
                policy_number: this.dependentsArray[dependentId]['policy_number'] || '',
                group_number: this.dependentsArray[dependentId]['group_number'] || '',
                driver_license_number: this.dependentsArray[dependentId]['driver_license_number'] || '',
                social_number: this.dependentsArray[dependentId]['social_number'] || '',
                id: this.dependentsArray[dependentId]['id'],
                insured_first_name: this.dependentsArray[dependentId]['insured_first_name'] || '',
                insured_middle_name: this.dependentsArray[dependentId]['insured_middle_name'] || '',
                insured_last_name: this.dependentsArray[dependentId]['insured_last_name'] || '',
                insured_gender: this.dependentsArray[dependentId]['insured_gender'] || '',
                insurance_same_as: this.dependentsArray[dependentId]['insurance_same_as'] || '',
                insured_date_of_birth: this.dependentsArray[dependentId]['insured_date_of_birth'] || '',
                insured_date_of_birth_pretty: this.dependentsArray[dependentId]['insured_date_of_birth'] || '',
                insured_address_components: insuredAddressInitial,
                insured_address: this.dependentsArray[dependentId]['insured_address'] || '',
                insured_address2: this.dependentsArray[dependentId]['insured_address2'] || '',
                relationship: this.dependentsArray[dependentId]['relationship'] || ''
              }
            }
          }
        }
      },
      callValidation () {
        this.$refs.medicationData['0'].validate()
      },
      async callValidationRegistration () {
        this.loadingAddDependent = true
        let medDataValidation = await this.$refs.medicationData.validate()
        if (medDataValidation === false) {
          this.loadingAddDependent = false
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      updateAddress (data) {
        this.model.addressComponents = data
        this.address_error = ''
      },
      async prepareData () {
        let one = process.env.SERVER_URI + '/account/get/dependents'
        let three = process.env.SERVER_URI + '/requirements/' + this.$store.state.sitecode
        let four = process.env.SERVER_URI + '/ethnicity/' + this.$store.state.sitecode
        let five = process.env.SERVER_URI + '/race/' + this.$store.state.sitecode
        let six = process.env.SERVER_URI + '/gender/' + this.$store.state.sitecode
        let two = process.env.SERVER_URI + '/insurance/' + this.$store.state.sitecode
        let seven = process.env.SERVER_URI + '/account/check/user'
        let eight = process.env.SERVER_URI + '/validate/site/' + this.$store.state.sitecode
        let email = localStorage.getItem('email')
        const requestThree = axios.get(three)
        const requestFour = axios.get(four)
        const requestFive = axios.get(five)
        const requestSix = axios.get(six)
        const requestTwo = axios.get(two)
        const requestOne = axios.post(one, {'email': email}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        const requestSeven = axios.post(seven, {'email': email}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        const requestEight = axios.get(eight)
        await axios.all([requestOne, requestThree, requestFour, requestFive, requestSix, requestTwo, requestSeven, requestEight])
            .then(axios.spread((...responses) => {
              if (responses[0].data === false) {
                this.$store.state.userData = []
              } else if (responses[0].data) {
                this.$store.state.dependentsData = responses[0].data
              }
              this.$store.state.requirements = {...this.$store.state.requirements, ...responses[1].data}
              this.$store.state.configs.ALLOW_DRIVER_LICENSE = this.$store.state.requirements.driver_license_image && this.$store.state.requirements.driver_license_image !== ''
              this.$store.state.configs.REQUIRED_DRIVER_LICENSE = this.checkRequirement('driver_license_image')
              this.$store.state.configs.ALLOW_INSURANCE_CARD = this.$store.state.requirements.insurance_card_image && this.$store.state.requirements.insurance_card_image !== ''
              this.$store.state.configs.REQUIRED_INSURANCE_CARD = this.checkRequirement('insurance_card_image')
              this.$store.state.ethnicity = responses[2].data
              this.$store.state.race = responses[3].data
              this.$store.state.gender = responses[4].data
              this.$store.state.insurance = responses[5].data
              if (responses[6].data) {
                let insuredAddressInitial = {}
                if (responses[6].data['insured_address_components']) {
                  insuredAddressInitial = {
                    name: responses[6].data['insured_address_components']['name'] || '',
                    original_name: responses[6].data['insured_address_components']['original_name'] || '',
                    delivery_line_1: responses[6].data['insured_address_components']['delivery_line_1'] || '',
                    city_name: responses[6].data['insured_address_components']['city_name'] || '',
                    county: responses[6].data['insured_address_components']['county'] || '',
                    state_abbreviation: responses[6].data['insured_address_components']['state_abbreviation'] || '',
                    zipcode: responses[6].data['insured_address_components']['zipcode'] || '',
                    plus4_code: responses[6].data['insured_address_components']['plus4_code'] || '',
                    county_fips: responses[6].data['insured_address_components']['county_fips'] || '',
                    country: responses[6].data['insured_address_components']['country'] || ''
                  }
                }
                this.$store.state.patientRegistrationData = {
                  first_name: responses[6].data['first_name'] || '',
                  last_name: responses[6].data['last_name'] || '',
                  date_of_birth: responses[6].data['date_of_birth'] || '',
                  primary_insurance: responses[6].data['insurance_name'] || '',
                  policy_number: responses[6].data['policy_number'] || '',
                  group_number: responses[6].data['group_number'] || '',
                  insured_first_name: responses[6].data['insured_first_name'] || '',
                  insured_middle_name: responses[6].data['insured_middle_name'] || '',
                  insured_last_name: responses[6].data['insured_last_name'] || '',
                  insured_gender: responses[6].data['insured_gender'] || '',
                  insured_date_of_birth: responses[6].data['insured_date_of_birth'] || '',
                  insured_date_of_birth_pretty: responses[6].data['insured_date_of_birth'] || '',
                  insured_address_components: insuredAddressInitial,
                  insured_address: responses[6].data['insured_address'] || '',
                  insured_address2: responses[6].data['insured_address2'] || '',
                  relationship: responses[6].data['relationship'] || ''
                }
              }
              if (responses[7].data === false) {
                this.view = false
              } else {
                this.$store.state.site = responses[7].data
                this.overwriteGraphSettings(responses[7].data)
              }
              this.view = true
            })).catch(error => {
              this.view = false
              console.log(error)
            })
      }
    },
    async beforeMount () {
      await this.prepareData()
    },
    watch: {
      '$store.state.dependentsData': {
        handler: function (after, before) {
          this.dependentsArray = this.$store.state.dependentsData
          this.editButton = ''
          this.addDependent = false
          this.loadingAddDependent = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";
>>> .el-select--large {
  width: 100%;
}
.loading-size {
  font-size: 70px;
  color: $primary-color !important;
}

.gender-float {
  text-align: right;
}
.padding-top {
  margin-top: 20px;
}

.text {
  font-size: 20px;
}
.turnGreen {
  color: $primary-color !important;
}
.beGrey {
  color: grey;
}
.signform {
  margin: auto;
  width: 400px;
  z-index: 1;
}

.button-edit {
  width: 120px !important;
  min-width: 100px;
  float: right;
  background: $primary-color !important;
  color: white;
  border-radius: 5px;
  &:hover {
    color: white !important;
  }
  &:focus {
    color: white !important;
  }
}
.button-back {
  width: 100px !important;
  background: white !important;
  color: $secondary-color;
  border-radius: 5px;
}
.buttonform {
  padding-top: 5px;
  margin: auto;
  width: 398px;
}
.pt-5 {
  padding-top: 5px;
}
.button {
  background: $primary-color;
  border-color: white !important;
  border-width: 3px;
  color: white;
}
.bg-color {
  background-color: white;
}
.bg--white {
  background-color: white;
}
.pr-10 {
  padding-right: 10px;
}
.p-10 {
  padding-top: 8px;
  padding-bottom: 1px;
  padding-right: 3px;
  padding-left: 3px;
}
.pb-40 {
  padding-bottom: 40px;
}
.pl-5 {
  padding-left: 5px;
}
.pt-5 {
  padding-top: 10px;
}
.result {
  text-align: center;
  font-size: 20px;
}
.icon {
  font-size: 20px;
}
.icon-button {
  font-size: 40px;
}
.rounded {
  border: 1px solid $default-grey;
  border-radius: 3px;
}
.fs-28 {
  font-size: 28px;
}
.fs-18 {
  font-size: 18px;
}
.ml-30 {
  margin-left: -30px;
}
.ml-30 {
  margin-right: -30px;
}
@media screen and (max-width: 450px) {
  .signform {
    margin: auto;
    width: 300px;
    z-index: 1;
  }
  .buttonform {
    padding-top: 5px;
    margin: auto;
    width: 300px;
  }
  .button-edit {
    float: left;
    width: 100% !important;
  }
  .button-back {
    margin-bottom: 2px;
    float: left;
    width: 100% !important;
  }
  .buttonform {
    padding-top: 5px;
    margin: auto;
    width: 300px;
  }
}
@media screen and (max-width: 365px) {
  >>> .el-radio-button--small .el-radio-button__inner {
    padding: 9px 7px;
  }
  .button-edit {
    float: left;
    width: 100% !important;
  }
  .button-back {
    margin-bottom: 2px;
    float: left;
    width: 100% !important;
  }
}
@media screen and (max-width: 991px) {
  .button-edit {
    float: left;
    width: 100% !important;
  }
  .button-back {
    margin-bottom: 2px;
    float: left;
    width: 100% !important;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/Dependents.vue